import { render, staticRenderFns } from "./ProjectCrmLeads.vue?vue&type=template&id=72721182&"
import script from "./ProjectCrmLeads.vue?vue&type=script&lang=js&"
export * from "./ProjectCrmLeads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports